import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static values = {
        selector: String, // Optionally narrow the selector to just the ones we need to reveal, ie tr => tr.d-none
    }

    // When the element enters viewport, toggle .d-none on the elements that
    // match the selector For example, if the element is a <tr> then this will
    // reveal all <tr> in parent <tbody> with .d-none
    connect() {
        this.observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    Array.from(
                        this.element.parentElement.querySelectorAll(
                            `${this.selectorValue || ''}.d-none`,
                        ),
                    ).forEach((element) => {
                        element.classList.remove('d-none')
                    })
                }
            },
            {
                root: null,
                threshold: 0.1,
            },
        )

        this.observer.observe(this.element)
    }

    disconnect() {
        this.observer.disconnect()
    }
}
